import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import { DialogContent } from "@material-ui/core";

const styles = (theme) => ({
  root: {
    position: "relative",
    margin: 0,
    padding: theme.spacing(2),
    background: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[100],
  },
  // optional content centered in the title bar (e.g. the main actions of a full screen dialog)
  center: {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, center, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {center ? <div className={classes.center}>{center}</div> : null}
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

export const MyDialog=({onClose,open,title,children,headerStyle,headerCenter,...rest}) => {
  return (
    <div>
      <Dialog onClose={onClose} open={open} {...rest}  >
        <DialogTitle id="customized-dialog-title" onClose={onClose}
      style={headerStyle}
      center={headerCenter}
      >
          {title}
        </DialogTitle>
        <DialogContent >
          {children}
        </DialogContent>
      </Dialog>
    </div>
  );
}
